import { rage, useObservable } from '~/rage';
import { Spawn } from '../Spawn/Spawn';
import { StyledContainer } from './SpawnList.styled';

const SpawnList = () => {
	const spawnPoints = useObservable(rage.spawnSelect.getSpawnPoints());

	return (
		<StyledContainer>
			{spawnPoints.map((item, index) => (
				<Spawn key={index} index={index} name={item.name} type={item.type} />
			))}
		</StyledContainer>
	);
};

export { SpawnList };
